import { z } from 'zod';

export const REASON_MAX = 1000;
export const MISSING_FIELDS_MAX = 20;

export const vendorRejectSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, { message: 'vendors.errors.reasonRequired' })
    .max(REASON_MAX, { message: 'vendors.errors.reasonTooLong' }),
});
export type VendorRejectValues = z.infer<typeof vendorRejectSchema>;

export const vendorResubmissionSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, { message: 'vendors.errors.reasonRequired' })
    .max(REASON_MAX, { message: 'vendors.errors.reasonTooLong' }),
  missingFields: z
    .array(z.string().trim().min(1).max(100))
    .min(1, { message: 'vendors.errors.missingFieldsRequired' })
    .max(MISSING_FIELDS_MAX, { message: 'vendors.errors.missingFieldsTooMany' }),
});
export type VendorResubmissionValues = z.infer<typeof vendorResubmissionSchema>;

export const vendorApproveSchema = z.object({
  reason: z
    .string()
    .trim()
    .max(REASON_MAX, { message: 'vendors.errors.reasonTooLong' })
    .optional()
    .or(z.literal('')),
});
export type VendorApproveValues = z.infer<typeof vendorApproveSchema>;

export const vendorCredentialIssueSchema = z.object({
  initialAdminEmail: z
    .string()
    .trim()
    .min(1, { message: 'vendors.errors.emailRequired' })
    .email({ message: 'vendors.errors.emailFormat' })
    .max(254, { message: 'vendors.errors.emailTooLong' }),
  initialAdminName: z
    .string()
    .trim()
    .min(1, { message: 'vendors.errors.nameRequired' })
    .max(100, { message: 'vendors.errors.nameTooLong' }),
});
export type VendorCredentialIssueValues = z.infer<typeof vendorCredentialIssueSchema>;

export const MISSING_FIELD_PRESETS = [
  'businessRegistration.fileQuality',
  'businessRegistration.expired',
  'telecomSalesRegistration.missing',
  'bankAccount.accountNumber',
  'bankAccount.holderMismatch',
  'representativeId.fileQuality',
  'businessPermit.missing',
  'contactInfo.phoneInvalid',
  'businessAddress.incomplete',
] as const;
export type MissingFieldPreset = (typeof MISSING_FIELD_PRESETS)[number];
